import api from './api';

export interface LoginRequest {
  email: string;
  password: string;
}

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
}

export interface LoginResponse {
  accessToken: string;
  refreshToken: string;
  accessTokenExpiresAt: string;
  user: User;
}

export const authService = {
  login: async (request: LoginRequest): Promise<LoginResponse> => {
    const response = await api.post<LoginResponse>('/saas-admin/auth/login', request);

    // Store token pair and user
    localStorage.setItem('saas_admin_token', response.data.accessToken);
    localStorage.setItem('saas_admin_refresh_token', response.data.refreshToken);
    localStorage.setItem('saas_admin_user', JSON.stringify(response.data.user));

    return response.data;
  },

  logout: () => {
    localStorage.removeItem('saas_admin_token');
    localStorage.removeItem('saas_admin_refresh_token');
    localStorage.removeItem('saas_admin_user');
  },

  getCurrentUser: (): User | null => {
    const userJson = localStorage.getItem('saas_admin_user');
    return userJson ? JSON.parse(userJson) : null;
  },

  isAuthenticated: (): boolean => {
    return !!localStorage.getItem('saas_admin_token');
  },

  getMe: async (): Promise<User> => {
    const response = await api.get<User>('/saas-admin/auth/me');
    return response.data;
  },
};
